import { useState } from "react";
import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const DatePicker = ({ date, onSelect, testId = "date" }) => {
  const [open, setOpen] = useState(false);

  const safeDate = (() => {
    if (!date) return null;
    const d = date instanceof Date ? date : new Date(date);
    return isNaN(d.getTime()) ? null : d;
  })();

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          data-testid={`${testId}-picker-trigger`}
          className={cn(
            "w-full justify-start h-14 bg-input border-2 border-border hover:border-primary/50 text-lg px-4 font-mono rounded-sm transition-colors",
            !safeDate && "text-muted-foreground/50"
          )}
        >
          <CalendarIcon className="mr-3 h-5 w-5" />
          {safeDate ? format(safeDate, "dd/MM/yyyy") : "SELECT DATE..."}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={safeDate}
          onSelect={(d) => { onSelect(d); setOpen(false); }}
          initialFocus
          data-testid={`${testId}-calendar`}
        />
      </PopoverContent>
    </Popover>
  );
};
